import { MicOff } from "lucide-react"
import { useEffect } from "react"

interface PermissionProps {
  onMount: () => void
}

export function Permission({ onMount }: PermissionProps) {
  useEffect(() => {
    onMount()
  }, [onMount])

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background">
      <MicOff className="size-16 text-greyscale-dark-grey mb-4" />
      <p className="text-body-medium text-center mb-4 px-8">
        To enable recording of task cards please allow microphone access.
      </p>
    </div>
  )
}
